<div style="display:flex; flex:1 0 auto; flex-direction:column; height:100%">
  <div class="form-header">
    <p>Sub Accounts for this account</p>
    <p *ngIf="!sessionService.hasRole(RoleType.ADMIN) && sessionService.isAccountType('SYSTEM')">
      Your role does not allow for saving settings changes on this screen.
    </p>
  </div>
  <div class="subaccount-table-wrapper">
    <cw-ci-data-table #subAccountDataTable
      tileTitle="Companies"
      addToolTip="Create a new company"
      refreshToolTip="Reload company list"
      defaultSortField="account_name"
      hidePageSize="true"
      hideRefreshButton="true"
      hideWrapper="true"
      pageSize="8"
      skipInitialLoad="true"
      [isSelectable]="isSelectable"
      (loadItemsHandler)="loadAccounts($event)"
      (selectHandler)="selectAccount($event)"
      [items]="accountList"
      class="subaccount-table">

      <cw-ci-table-column columnName="active" columnTitle="Active" [output]="activeTemplate" searchField="active" filterType="select" [filterOptions]="[{display:'Active', value:'true'}, {display:'Inactive', value:'false'}]"></cw-ci-table-column>
      <ng-template let-element #activeTemplate><mat-icon color="accent" *ngIf="element.isActive">check</mat-icon></ng-template>

      <cw-ci-table-column columnName="name" columnTitle="Company Name" sortField="account_name" searchField="account_name" filterType="text" [output]="companyNameTemplate"></cw-ci-table-column>
      <ng-template let-element #companyNameTemplate>{{element.name}} (id: {{element.id}})</ng-template>
      <cw-ci-table-column columnName="summary.completedAssessments" columnTitle="Completed Assessments" sortField="completed_assessments"></cw-ci-table-column>
      <cw-ci-table-column columnName="summary.totalAssessments" columnTitle="Total Assessments" sortField="total_assessments"></cw-ci-table-column>

      <cw-ci-table-column columnName="actions" columnTitle="Actions" [output]="actionTemplate"></cw-ci-table-column>
      <ng-template let-element #actionTemplate>
        <cw-ci-table-column-action [disabled]="!element.isActive" actionToolTip="Edit the Company" svgIcon="cw:application_configuration" actionColor="primary" [element]="element" (clickHandler)="selectAccount($event)"></cw-ci-table-column-action>
        <cw-ci-table-column-action [visible]="element.type != 'SYSTEM' && element.isActive" [disabled]="!sessionService.hasRole(RoleType.ADMIN) && sessionService.isAccountType('SYSTEM')" actionToolTip="Deactivate the Company" matIcon="delete" actionColor="primary" [element]="element" (clickHandler)="deleteAccount($event)"></cw-ci-table-column-action>
        <cw-ci-table-column-action [visible]="element.type != 'SYSTEM' && !element.isActive" [disabled]="!sessionService.hasRole(RoleType.ADMIN) && sessionService.isAccountType('SYSTEM')" actionToolTip="Delete the Company" matIcon="delete_forever" actionColor="warn" [element]="element" (clickHandler)="deleteAccount($event)"></cw-ci-table-column-action>
      </ng-template>
    </cw-ci-data-table>
  </div>
</div>